import React from 'react';
import { PropertyListItem } from '../../../components/Redesing/property-list-item';
import { SeverityPill } from '../../../components/Redesing/severity-pill';
import { LocationStats } from '../../../ts/interface/station.interface';

interface LocationStatsCardProps {
  stats: LocationStats;
}

const LocationStatsCard: React.FC<LocationStatsCardProps> = ({ stats }) => {
  const renderStat = (label: string, value: number | undefined, round = false) => (
    <PropertyListItem divider label={label}>
      {value ? (
        <>{round ? Number(value).toFixed(2) : value}</>
      ) : (
        <SeverityPill color="info">N/A</SeverityPill>
      )}
    </PropertyListItem>
  );

  return (
    <div data-id="station-stats">
      {renderStat('Rentals started', stats?.total_rentals_started)}
      {renderStat('Rentals ended', stats?.total_rentals_ended)}
      {renderStat('Rentals started/User (avg)', stats?.avg_rental_started_per_user, true)}
      {renderStat('Rentals ended/User (avg)', stats?.avg_rental_ended_per_user, true)}
    </div>
  );
};

export default LocationStatsCard;
